export const GSH = 'ca50d052-ec4e-461f-91a2-fa93c17b01e8';